import { render, staticRenderFns } from "./HandoverAgentChatLimitPerUser.vue?vue&type=template&id=a45f0940&"
import script from "./HandoverAgentChatLimitPerUser.vue?vue&type=script&lang=js&"
export * from "./HandoverAgentChatLimitPerUser.vue?vue&type=script&lang=js&"
import style0 from "./HandoverAgentChatLimitPerUser.vue?vue&type=style&index=0&id=a45f0940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports